import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import FilterMultiSelect from "./FilterMultiSelect";

const CitySearch = withLiteObserverAndTheme(() => {
  const shouldShow =
    getKhattabatMatchingStore().isCitySearchAvailable.get() &&
    !getKhattabatMatchingStore().isChosenResidenceCountriesExcluded.get();

  return !shouldShow ? null : (
    <Grid size={{ xs: 12, md: 8, lg: 6 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <FilterMultiSelect
            label={i18n.get("CITY_OF_RESIDENCE")}
            options={getKhattabatMatchingStore().availableCityOptions.get()}
            value={getKhattabatMatchingStore().matchResidenceCityFilter.get()}
            onChange={getKhattabatMatchingStore().setMatchResidenceCityFilter}
          />
        </Stack>
        <Button
          variant="outlined"
          onClick={() => getKhattabatMatchingStore().getAvailableCities()}
          sx={{ flexShrink: 0 }}
        >
          {i18n.get("GET_CITIES")}
        </Button>
      </Stack>
    </Grid>
  );
});

export default CitySearch;
